<template>
  <div>
    <el-card>
      <div slot="header" class="clearfix">
        <span style="color: #409EFF">物流点数充值</span>
      </div>
      <el-button type="primary" size="small" style="margin: 0 0 10px 20px"
                 icon="el-icon-plus" @click="handleAdd('立即充值')">立即充值
      </el-button>

      <el-table :data="tableData"
                ref="table"
                border default-expand-all stripe
                :max-height="tableHeight"
                style="width: 100%;margin-bottom: 20px;"
                :header-cell-style="{'text-align':'center'}"
                :cell-style="{'text-align':'center'}">
        <el-table-column prop="investExpressNumber" label="充值编号"/>
        <el-table-column prop="createTime" label="提交时间"/>
        <el-table-column prop="expressManage" label="充值物流"/>
        <el-table-column prop="expriceInfo" label="充值单价 (金币/点)">
          <template slot-scope="scope">
            <span style="color: red;">{{expressOptions.find(item=>item.id == scope.row.b2cExpressManageId).expressPrice}}</span>
          </template>
        </el-table-column>
        <el-table-column prop="investExpress" label="充值点数"/>
        <el-table-column prop="accountExpressNum" label="物流剩余点数"/>
        <el-table-column prop="remarks" label="备注"/>
      </el-table>
      <el-pagination
          :page-sizes="[20, 50, 100, 200]"
          layout="total, sizes, prev, pager, next, jumper"
          :current-page="pagination.pageNum"
          :page-size="pagination.pageSize"
          :total="pagination.total"
          @size-change="handlePageSizeChange"
          @current-change="handlePageNumChange"
          background
          style="float: right;margin-bottom: 10px">
      </el-pagination>
    </el-card>

    <el-dialog :title="dialogTitle" :visible.sync="dialogFormVisible">
      <el-form ref="dialogForm" :model="dialogForm" label-width="260px">
        <el-row :gutter="5">
          <el-col :span="24">
            <el-form-item label="请选择充值物流" prop="payBack">
              <el-select v-model="dialogForm.b2cExpressManageId" clearable placeholder="请选择">
                <el-option
                    v-for="item in expressOptions"
                    :key="item.id"
                    :label="item.expressName"
                    :value="item.id"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="24">
            <el-form-item label="充值点数" prop="investMoney">
              <el-input v-model="dialogForm.investExpress" placeholder="输入点数"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="24">
            <el-form-item label="合计金额">
              <span style="color: red">{{getPriceWithExpress}}</span>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="24" style="text-align: center">
            <span style="color: red;text-align: center;width: 100%;">提示: 用多少充多少，物流点数不能提现和兑换资金。</span>
          </el-col>
        </el-row>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="submitDialogForm()" size="mini" type="primary">确认充值</el-button>
        <el-button @click="handleCloseDialog" size="mini">取 消</el-button>
      </div>
    </el-dialog>
    <customer-service-component></customer-service-component>
  </div>
</template>

<script>
import MixinCUD from '@/components/MixinCUD';
import {getAllListExpress, getExpressUserManageList, addExpressUserManage} from "../../api/b2cbusiness/b2c_express";
import CustomerServiceComponent from "../../components/CustomerServiceComponent";
import MinxinScroll from "@/components/MinxinScroll";

export default {
  name: "ExpressInvestMoney",
  mixins: [MixinCUD, MinxinScroll],
  components:{CustomerServiceComponent},
  data() {
    return {
      tableData: [],
      expressOptions:[],
      queryForm: {
        reciverMoneyType: "银行卡",
        accountNumber: "6215686300004271725",
        accountName: "王毅",
        openAccountBack: "中国银行 徐州支行",
        payBack: "",
        investMoney: ""
      },
      dialogFormVisible: false,
      dialogTitle: "",
      dialogRefName: "dialogForm",
      dialogForm: {
        b2cExpressManageId: 0,
        investExpress: 0,
        expressPrice: 0.00
      },
      tableHeight: 450,
      pagination: {
        pageNum: 1,
        pageSize: 20,
        total: null
      },
    }
  },
  created() {
    this.tableHeight = document.documentElement.clientHeight - 320;
    //console.log(document.body.clientHeight, this.tableHeight)
  },
  mounted() {
    getAllListExpress().then(res=>{
      console.log(res.data);
      if (res.success){
        this.expressOptions = res.data;
      }
    });

    getExpressUserManageList({}, this.pagination).then(res=>{
      console.log(res.data);
      if (res.success){
        this.tableData = res.data.records;
        this.pagination.pageNum = res.data.current;
        this.pagination.pageSize = res.data.size;
        this.pagination.total = res.data.total;
      }
    });
  },
  computed:{
    getPriceWithExpress(){
      console.log(this.expressOptions)
      if (this.dialogForm.b2cExpressManageId > 0 && this.dialogForm.investExpress != null){
        console.log(this.dialogForm.b2cExpressManageId)
        let expressInfo = this.expressOptions.find(item=>item.id == this.dialogForm.b2cExpressManageId);
        console.log(expressInfo);
        return this.dialogForm.investExpress + " X " + expressInfo.expressPrice+"="+this.dialogForm.investExpress * expressInfo.expressPrice;
      }else{
        return 0;
      }
    }
  },
  methods:{
    addData(){
      addExpressUserManage(this.dialogForm).then(res=>{
        this.$message({message: res.data, type: 'success'});
        this.submitQueryForm();//新增之后，重新查询table
        this.handleCloseDialog();
      });
    },
    getData(){
      getExpressUserManageList({
        id:this.queryForm.id,
        b2cExpressManageId:this.queryForm.b2cExpressManageId,
      },this.pagination).then(res=>{
        console.log(res.data);
        if (res.success){
          this.tableData = res.data.records;
          this.pagination.pageNum = res.data.current;
          this.pagination.pageSize = res.data.size;
          this.pagination.total = res.data.total;
        }
      });
    },
    handlePageSizeChange(val){
      this.pagination.pageSize = val;
      this.submitQueryForm()
    },
    handlePageNumChange(val){
      this.pagination.pageNum = val;
      this.submitQueryForm()
      //切换页面恢复到顶部
      this.scrollTop = 0
      this.saveScroll()
    },
  }
}
</script>

<style scoped>
.el-form {
  margin-top: 20px;
}
</style>
